import React from "react";
import { ReactComponent as ConflictSvg } from "../../assets/icons/conflict.svg";

export default function ConflictIcon({ size = 20, className = "" }) {
  return (
    <ConflictSvg
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
    />
  );
}
